import { buildUrl, contextAwareHeaders } from './apiClient';

const parseJson = async (response) => response.json().catch(() => ({}));

export const fetchHomepageFeed = async ({ latitude, longitude, city = '', state = '', country = '', signal } = {}) => {
  const url = new URL(buildUrl('/api/homepage'));
  if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
    url.searchParams.set('latitude', String(latitude));
    url.searchParams.set('longitude', String(longitude));
  }
  if (city) url.searchParams.set('city', city);
  if (state) url.searchParams.set('state', state);
  if (country) url.searchParams.set('country', country);

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: contextAwareHeaders(),
    signal,
  });

  const data = await parseJson(response);

  if (!response.ok) {
    const error = new Error(data?.error || 'Unable to load homepage feed.');
    error.status = response.status;
    throw error;
  }

  return {
    liveMatches: Array.isArray(data?.liveMatches) ? data.liveMatches : [],
    upcomingMatches: Array.isArray(data?.upcomingMatches) ? data.upcomingMatches : [],
    ongoingTournaments: Array.isArray(data?.ongoingTournaments) ? data.ongoingTournaments : [],
    upcomingTournaments: Array.isArray(data?.upcomingTournaments) ? data.upcomingTournaments : [],
  };
};
